<script setup>
import ChargemapB2CButton from "./ChargemapB2CButton.vue";
defineProps({
  ctaText: { type: String, required: false, default: "" },
  imagePath: { type: String, required: false, default: "" },
  imagePosition: { type: String, required: false, default: "right" },
  icon: { type: [String, null], required: false, default: null },
  iconIsSolid: { type: Boolean, required: false, default: false },
  href: { type: String, required: true, default: "" }
});
</script>

<template>
    <div
        class="p-6 pr-0 bg-sky-100 rounded-lg justify-start items-center md:items-start gap-6 inline-flex"
        :class="
  imagePath && imagePosition === 'left' && 'flex-row-reverse pr-6'
"
    >
        <div
            class="grow shrink basis-0 pt-4 flex-col justify-center items-start gap-4 inline-flex"
        >
            <div class="self-stretch">
                <span class="text-zinc-800 text-base font-bold leading-tight">
                    <slot name="text" />
                </span>
            </div>
            <a :href :title="ctaText">
                <ChargemapB2CButton
                    type="primary"
                    size="large"
                    custom="less-padding"
                >
                    <component
                        :is="icon"
                        v-if="icon"
                        class="size-6"
                        :is-solid="iconIsSolid"
                    />
                    {{ ctaText }}
                </ChargemapB2CButton>
            </a>
        </div>
        <img
            v-if="imagePath"
            :src="imagePath"
            :alt="ctaText"
            class="h-16 md:h-24 lg:h-36"
        />
    </div>
</template>
